import { useCallback, useLayoutEffect, useRef } from 'react'

export const useStableCallback = <A extends unknown[], R>(callback: (...args: A) => R) => {
    const callbackRef = useRef(callback)

    useLayoutEffect(() => {
        callbackRef.current = callback
    })

    return useCallback((...args: A) => callbackRef.current(...args), [])
}
